import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { retry, catchError, tap, take, first, timeout } from 'rxjs/internal/operators';
import { environment } from 'src/environments/environment';
import { Enrollment } from 'src/app/modals/enrollment.model';
import { FindEnrollerResponse } from 'src/app/modals/findenroller.modal';
import { GetWebSiteInformationResult } from 'src/app/modals/getwebsiteinfo.modal';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {
  public loginStatus = new BehaviorSubject<boolean>(this.hasToken());
  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.getheaders();
  }

  getheaders(): any {
    let httpOptions: any;
    if (this.cookieService.get('X-Auth')) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          "Authorization": "Bearer " + this.cookieService.get('X-Auth')
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8'
        })
      };
    }
    return httpOptions;
  }
  // Error handling
  handleError(error) {
    let errorMessage = '';
    
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(error);
  }

  isLoggedIn(): Observable<boolean> {
    return this.loginStatus.asObservable();
  }
  private hasToken(): boolean {
    return this.cookieService.check('X-Auth');
  }
  // Address  Controller
    getActiveCountries(): Observable<any> {
    if (sessionStorage.getItem('allowedCountries')) {
      const allowedCountries = new Observable(observer => {
        observer.next(JSON.parse(sessionStorage.getItem('allowedCountries')));
        observer.complete();
      });
      return allowedCountries;
    }
    else {
      const response = this.http.get<any>(`${environment.productUrl}api/Address/GetActiveCountries`, this.getheaders())
        .pipe(
          retry(1),
           catchError(this.handleError)
        );
      response.subscribe((result) => {
        sessionStorage.setItem('allowedCountries', JSON.stringify(result));
      }, (error) => {
        // Handle error silently
      });
      return response;
    }
  }

  getRegionID(stateCode: string, countryCode: string): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Address/GetRegionID​`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getStates(countryCode: string): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Address/GetStates?countryCode=${countryCode}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Company  Controller
  getCompanyDetails(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Company/Details`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


  postCustomData(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Custom/PostCustomData`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  postCustomDatatoExtension(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Custom/PostCustomDatatoExtension`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Customers Controller

  addCustomerRewardPoints(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/AddCustomerRewardPoints`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  calculateCustomerOrderTotal(request): Observable<any> {

    return this.http.post<any>(`${environment.productUrl}api/Customers/CalculateCustomerOrderTotal`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  createProspect(request): Observable<any> {

    return this.http.post<any>(`${environment.productUrl}api/DiscoApi/CreateProspect`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


  createCustomer(request: any): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/CreateCustomer`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        timeout(30000), // 30 second timeout
        catchError(this.handleError)
      );
  }

  createCustomerAutoshipOrder(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/CreateCustomerAutoshipOrder`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  createCustomerOrder(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/CreateCustomerOrder`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  createCustomerOrderAndAutoship(request: any): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/CreateOrderAutoOrder`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  createCustomerServiceLogEntry(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/CreateCustomerServiceLogEntry`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  createPaymentMethod(request): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/CreatePaymentMethod`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deductCustomerRewardPoints(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/DeductCustomerRewardPoints`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  deleteCustomerAutoship(autoshipid: any): Observable<any> {

    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromString: 'autoshipId=' + autoshipid });
    return this.http.get<any>(`${environment.productUrl}api/Customers/DeleteAutoship`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deleteCustomer(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/DeleteCustomer`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deletePaymentMethod(request: any): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromObject: request });
    return this.http.post<any>(`${environment.productUrl}api/Customers/DeletePaymentMethod`, '', requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomer(customerID?: any): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomer?customerId=${customerID}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getSearchCustomerDetail(customerID: number): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetSearchCustomerDetail?customerId=${customerID}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


  getCustomerAutoships(customerID?): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerAutoships?customerId=${customerID}&includeServiceAutoships=true`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerCountries(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerCountries`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerCustomFields(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerCustomFields`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerDownlineIds(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerDownlineIds`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerIDs(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerIDs`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerIDsbyFilter(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerIDsbyFilter`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerOrders(customerId): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerOrders?customerId=${customerId}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerOrderDetail(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerOrderDetail`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerParties(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerParties`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerPartyTotals(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerPartyTotals`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerRewardPoints(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerRewardPoints`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  GetCustomerRewardPoints(customerId) {
    return this.http
      .get<any>(
        `${environment.productUrl}api/Customers/GetCustomerRewardPoints?customerId=${customerId}`,
        this.getheaders(),
      )
      .pipe(retry(1), catchError(this.handleError));
  }
  getCustomerSavedPaymentMethods(request: any): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerSavedPaymentMethods`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerServices(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerServices`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerStats(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerStats`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomersByParameter(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomersByParameter`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomersDataPoints(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/GetCustomersDataPoints`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomersToPlaceTo(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomersToPlaceTo`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getDataPointCategories(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetDataPointCategories`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getNotificationEvents(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetNotificationEvents`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getPaymentMerchants(request): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetPaymentMerchants`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getPaymentMethodIFrame(request): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetPaymentMethodIFrame`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getPaymentMethodIFrameTempUser(request): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetPaymentMethodIFrameTempUser`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getUnplacedCustomers(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetUnplacedCustomers`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getWebsiteInformation_V1(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetWebsiteInformation_V1`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getWebsiteInformation(Webalias): Observable<any> {
    return this.http.get<GetWebSiteInformationResult>(`${environment.productUrl}api/Customers/GetWebsiteInformation?webAlias=${Webalias}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  placeNode(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/PlaceNode`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

 
  resetPassword(customerId, request:any): Observable<any> {
    return this.http
      .put<any>(
        `${environment.productUrl}api/Customers/ResetPassword?customerId=${customerId}`,
        request,
        this.getheaders(),
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  searchAssociate(req: any): Observable<any> {
    return this.http.get<FindEnrollerResponse>(`${environment.productUrl}api/Customers/SearchAssociate?searchTerm=${req.searchTerm}&includeWebAliases=${req.includeWebAliases}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  submitEnrollmentForm(request: Enrollment): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/SubmitEnrollmentForm`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updateAutoShipDateandAmount(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Customers/UpdateAutoShipDateandAmount`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updateCustomer(req:any): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Customers/UpdateCustomer`,req, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updateCustomerByParameter(): Observable<any> {
    return this.http.patch<any>(`${environment.productUrl}​/api/Customers/UpdateCustomerByParameter`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  usernameAvailabilityCheck(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/UsernameAvailabilityCheck`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  sendWelComeEmail(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Customers/SendWelComeEmail`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Echo  Controller


  ping(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Echo/Ping`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  pingDeep(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Echo/PingDeep`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Office  Controller


  getMediaResources(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Office/GetMediaResources`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getNotificationSettings(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Office​/GetNotificationSettings`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getTrainingDetailsandProgress(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Office​/GetTrainingDetailsandProgress`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  triggerForgotPasswordProcess(request): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}TriggerForgotPasswordProcess`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  //  /api/Validate/ValidateResetPasswordToken

  // secondForgotPasswordProcess(request): Observable<any> {
  //   return this.http.post<any>(`${environment.productUrl}api/Validate/ValidateResetPasswordToken`, JSON.stringify(request), this.getheaders())
  //     .pipe(
  //       retry(1),
  //       catchError(this.handleError)
  //     );
  // }

  thirdForgotPasswordProcess(customerid: number, request: any): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Customers/ResetPassword?customerId=${customerid}`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  //  /api/Customers/ResetPassword
  // Orders  Controller


  cancelOrder(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders/CancelOrder`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deleteAutoship(autoshipid: number): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromString: 'autoshipId=' + autoshipid });
    return this.http.post<any>(`${environment.productUrl}api/Orders/DeleteAutoship`, '', requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  enqueueStats(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/EnqueueStats`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getAutoship(autoorderid): Observable<any> {
    const requestquery = this.getheaders();
    requestquery['params'] = new HttpParams({ fromString: 'autoshipId=' + autoorderid });
    return this.http.get<any>(`${environment.productUrl}api/Orders/GetAutoship`, requestquery)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getOrder(orderId: number): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders/GetOrder?orderId=${orderId}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderIds(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderIds`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderIdsFilter(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderIdsFilter`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderPackageDetails(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderPackageDetails`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderRMAs(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderRMAs`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderType(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderType`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getOrderTypes(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetOrderTypes`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getPriceGroup(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetPriceGroup`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getPriceGroups(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetPriceGroups`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getShippingMethod(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetShippingMethod`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getShippingMethods(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetShippingMethods`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getUnshippedPackages_Deprecated(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Orders​/GetUnshippedPackages_Deprecated`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  importExternalOrder(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/ImportExternalOrder`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  insertPayments(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/InsertPayments`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  refundPayment(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/RefundPayment`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  sendOrderReceipt(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/SendOrderReceipt`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  setOrderShipped_Deprecated(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/SetOrderShipped_Deprecated`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  setPackageReturned_Deprecated(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/SetPackageReturned_Deprecated`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  setPackageShipped_Deprecated(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/SetPackageShipped_Deprecated`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  splitPackage(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Orders/SplitPackage`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updateAutoship(autoshipid: number, request: any): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/UpdateAutoship/${autoshipid}`, JSON.stringify(request), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updatePackageStatus(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/UpdatePackageStatus`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updatePackageStatusBatch(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Orders/UpdatePackageStatusBatch`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Products Controller


  deleteItem(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products/DeleteItem`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getItembyId(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products​/GetItembyId`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getItembySKU(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products​/GetItembySKU`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getItems(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products/GetItems`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getItemsbyFilter(request: any): Observable<any> {
    const getItemsrequest = this.getheaders();
    getItemsrequest['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Products/GetItemsbyFilter`, getItemsrequest)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getRegions(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products/GetRegions`, this.getheaders())
      .pipe(
        retry(1),
         catchError(this.handleError)
        // catchError((error) => {
        //   console.error('GetRegions API error:', error);
          
        //   // Return fallback data for development
        //   if (error.status === 500) {
        //     console.log('Using fallback data for GetRegions due to 500 error');
        //     const fallbackData = {
        //       Status: 0,
        //       Data: [
        //         {
        //           ID: 1,
        //           RegionName: "North America",
        //           CountryList: [
        //             {
        //               CountryCode: "US",
        //               CountryName: "United States"
        //             },
        //             {
        //               CountryCode: "CA", 
        //               CountryName: "Canada"
        //             }
        //           ]
        //         }
        //       ]
        //     };
        //     return new Observable(observer => {
        //       observer.next(fallbackData);
        //       observer.complete();
        //     });
        //   }
          
        //   return this.handleError(error);
        // })
      );
  }

  getStockLevel(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products/GetStockLevel`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getStores(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products/GetStores`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getSubCategories(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products​/GetSubCategories`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getWarehouses(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Products​/GetWarehouses`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getTopSellingProducts(request: any): Observable<any> {
    const getTopSellingrequest = this.getheaders();
    getTopSellingrequest['params'] = new HttpParams({ fromObject: request });
    return this.http.get<any>(`${environment.productUrl}api/Products/GetTopSellingProducts`, getTopSellingrequest)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  updateStockLevel(): Observable<any> {
    return this.http.put<any>(`${environment.productUrl}api/Products/UpdateStockLevel`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // RMAs  Controller


  createRMA(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/RMAs/CreateRMA`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  deleteRMA(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/RMAs​/DeleteRMA`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getRMA(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/RMAs​/GetRMA`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getRMAs(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/RMAs​/GetRMAs`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  markRMAReceived(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/RMAs/MarkRMAReceived`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  markRMAShipped(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/RMAs/MarkRMAShipped`, JSON.stringify({}), this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // SSO  Controller


  getCustomerBySSOToken(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/SSO​/GetCustomerBySSOToken`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getAdminBySSOToken(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/SSO​/GetAdminBySSOToken`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCustomerSSOURLByExternalId(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/SSO​/GetCustomerSSOURLByExternalId`, this.getheaders())
      .pipe(
        take(1),
        retry(1),
        catchError(this.handleError)
      );
  }

  // Utilities  Controller


  clearCache(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Utilities/ClearCache`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getError(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Utilities​/GetError`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getStatus(): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Utilities​/GetStatus`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // Validate  Controller
  validateEmailAddress(request): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Validate/EmailAddress?EmailAddress=${request.EmailAddress}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  getCustomerSSOURL(request: any): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/SSO/GetCustomerSSOURL?CustomerID=${request.CustomerID}&Dest=${request.Dest}`, this.getheaders())
      .pipe(
        first(),
        take(1),
        catchError(this.handleError)
      );
  }
  GetcountrybyipAddress():Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCountryByIpAddress`, this.getheaders()).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  Login(request: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${environment.productUrl}api/Validate/Login`, JSON.stringify(request), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8'
      }),
      observe: 'response'
    })
      .pipe(
        retry(1),
        tap((resp: HttpResponse<any>) => {
          if (resp.headers && resp.headers.get('X-Auth')) {
            this.cookieService.set('X-Auth', resp.headers.get('X-Auth'), null, '/');
            this.getheaders();
          }
          return resp;
        }),
        catchError(this.handleError)
      );
  }

  Logout(): Observable<any> {
    return this.http.post<any>(`${environment.productUrl}api/Validate/Logout`, '', this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  validateTaxId(taxId: string) {
    return this.http.get<any>(`${environment.productUrl}api/Validate​/TaxId?taxId=${taxId}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  validateUsername(username: string): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Validate/Username?username=${username}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  validateWebAlias(webAlias: string) {
    return this.http.get<any>(`${environment.productUrl}api/Validate/WebAlias?webAlias=${webAlias}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCompanyCountryLanguages() {
    return this.http.get<any>(`${environment.productUrl}api/Common/GetCompanyCountryLanguages`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  
  handleCustomerSSO(customerID:string): Observable<any> {
    return this.http
      .get<any>(
        `${environment.productUrl}api/SSO/GetCustomerSSOURL?CustomerID=${customerID}`,
        this.getheaders(),
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  uploadCustomerProfileImage(customerId: string, file: File): Observable<any>{
    const formData = new FormData();
    formData.append('customerId', customerId);
    formData.append('image', file, file.name);

    return this.http.put(`${environment.productUrl}api/Customers/UploadCustomerProfileImage`, formData, {
      headers: {
        'Accept': 'text/plain',
        "Authorization": "Bearer " + this.cookieService.get('X-Auth')
      },
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  fetchCustomerBalance(merchantId: number, customerId: string): Observable<any> {
    return this.http.get<any>(`${environment.productUrl}api/Customers/GetCustomerBalance?merchantId=${merchantId}&customerId=${customerId}`, this.getheaders())
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
}
